import React, { useEffect, useState } from 'react';

const useDebouncedOnChange = (initialValue, action, wait = 300) => {
  const [internalValue, setInternalValue] = useState(initialValue);
  const [timeoutId, setTimeoutId] = useState(-1);

  useEffect(() => {
    if (timeoutId !== -1) {
      setTimeoutId(clearTimeout(timeoutId));
    }

    setTimeoutId(setTimeout(action, wait));
  }, [internalValue]);

  return [internalValue, setInternalValue];
};

export default useDebouncedOnChange;
